import { cva } from 'class-variance-authority'

export const rootStyles = cva(
  [
    'min-w-[300px]',
    'flex',
    'flex-col',
    'h-full',
    'min-h-screen', // ensure it grows full height
    'background-app',
    'sm:max-w-1/5',
    'lg:max-w-1/5',
    'sm:p-6',
    'lg:p-6',
  ],
  {
    variants: {},
    defaultVariants: {},
  }
)

export const footerStyles = cva(['mt-auto', 'pt-6'], {
  variants: {
    showShadow: {
      true: 'shadow-[0_-4px_4px_-2px_rgba(0,0,0,0.05)]',
    },
  },
})

export const footerMenuStyles = cva([
  'flex',
  'items-center',
  'justify-between',
  'w-full',
  'cursor-pointer',
  'py-1',
  'pl-2',
  'pr-4',
  'border-none',
  'hover:bg-moss-50',
  'rounded-2xl',
  'cursor-pointer',
])

export const listStyles = cva(['flex', 'flex-col', 'p-0'])

export const listItemStyles = cva([
  'flex',
  'flex-row',
  'items-center',
  'px-2',
  'py-1.5',
  'mb-0',
  'cursor-pointer',
  'hover:bg-neutral-50',
  'rounded-2xl',
])

export const iconStyles = cva(['mr-2', 'h-4', 'w-4', 'flex-shrink-0'])

export const pageItemStyles = cva(
  ['p-0', 'border-none', 'cursor-pointer', 'my-2'],
  {
    variants: {
      disabled: {
        true: 'cursor-default',
      },
    },
  }
)

export const pageAccordionTriggerStyles = cva(
  `
  flex
  items-center
  justify-between
  w-full
  h-10
  py-3
  px-1
  gap-5
  hover:bg-moss-50
  rounded-2xl
  cursor-pointer
  pr-4
  `,
  {
    variants: {
      isActive: {
        true: 'bg-moss-50',
      },
    },
  }
)

export const pageListItemStyles = cva(
  `
  flex
  items-center
  h-10
  p-3
  m-0
  hover:bg-moss-50
  rounded-2xl
  cursor-pointer
  mb-1
  `,
  {
    variants: {
      isActive: {
        true: 'bg-moss-50',
      },
    },
  }
)

export const pageDivItemStyles = cva([
  'py-1',
  'px-1',
  'border-none',
  'hover:bg-moss-50',
  'rounded-2xl',
  'cursor-pointer',
])
